import { Fragment } from 'react';
import { Trans } from '@lingui/macro';
import { ListSubHeader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useFeatures } from 'app/domains/features/hooks/useFeatures';
import { FEATURE_LEGAL_SUPPORT, FEATURE_CALL_AND_CHECK } from 'app/domains/features/utils';
import { useAutotagFeatureAvailability } from 'app/domains/metadata';
import { useRole } from 'app/domains/users/hooks/useRole';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { ContactSupport } from './ContactSupport';
import { NavItem } from './NavItem';
import { SavedViewListItem } from './SavedViewListItem';
import { StyledList } from './styled';
export function NavigationMenu() {
    const userRole = useRole();
    const features = useFeatures();
    const sharedWithMeFeature = useFeatureFlag('feature_shared_with_me');
    const allDocumentsRoute = useFeatureFlag('feature_all_documents_route');
    const autotagFeature = useAutotagFeatureAvailability();
    const unverifiedTagsRoute = autotagFeature.data;
    const shouldDisplayLegalExpert = [FEATURE_LEGAL_SUPPORT, FEATURE_CALL_AND_CHECK].some(feature => features.includes(feature));
    return (<Fragment>
      <StyledList forwardedAs="nav">
        <ListSubHeader>
          <Trans comment="Discover sidebar section text">Discover</Trans>
        </ListSubHeader>

        <NavItem to="/dashboard" matchExact matchPath={['/dashboard', '/documents/*']}>
          <Falcon icon="grid-2"/>
          <Trans comment="Link to dashboard">Dashboard</Trans>
        </NavItem>

        <NavItem to="/insights" matchExact matchPath={['/insights']}>
          <Falcon icon="chart-simple"/>
          <Trans comment="Link to Insights">Insights</Trans>
        </NavItem>

        <NavItem to="/tasks" matchPath={['/tasks']}>
          <Falcon icon="list-check"/>
          <Trans comment="Link to tasks">Tasks</Trans>
        </NavItem>
      </StyledList>
      <StyledList forwardedAs="nav">
        <ListSubHeader>
          <Trans comment="Documents sidebar section text">Documents</Trans>
        </ListSubHeader>

        {allDocumentsRoute && (<NavItem matchPath={['/all-documents']} to="/all-documents">
            <Falcon icon="search"/>
            <Trans comment="Link to all documents">All Documents</Trans>
          </NavItem>)}

        <NavItem matchPath={['/files/:folderId?']} to="/files">
          <Falcon icon="rectangle-vertical-history"/>
          <Trans comment="Link to Files">Files</Trans>
        </NavItem>

        {sharedWithMeFeature && (<NavItem matchPath={['/shared-with-me/:folderId?']} to="/shared-with-me">
            <Falcon icon="folder-user"/>
            <Trans comment="Link to files shared with me">Shared with me</Trans>
          </NavItem>)}

        <NavItem to="/drafts" matchPath={['/drafts']}>
          <Falcon icon="pen-to-square"/>
          <Trans comment="Link to drafts">Drafts</Trans>
        </NavItem>

        {unverifiedTagsRoute && (<NavItem to="/unverified-tags" matchPath={['/unverified-tags']}>
            <Falcon icon="shield"/>
            <Trans comment="Sidebar link to unverified tags">Unverified tags</Trans>
          </NavItem>)}

        <NavItem matchPath={['/contracts']} to="/contracts">
          <Falcon icon="files"/>
          <Trans comment="Link to templates">Templates</Trans>
        </NavItem>

        {allDocumentsRoute && <SavedViewListItem />}
      </StyledList>
      <StyledList forwardedAs="nav">
        <ListSubHeader>
          <Trans comment="Support sidebar section text">Support</Trans>
        </ListSubHeader>

        {shouldDisplayLegalExpert && (<NavItem matchPath={['/expert']} to="/expert">
            <Falcon icon="message-lines"/>
            <Trans comment="Link to legal support">Legal support</Trans>
          </NavItem>)}

        <ContactSupport />
      </StyledList>

      <StyledList forwardedAs="nav">
        <ListSubHeader>
          <Trans comment="Settings sidebar section text">Settings</Trans>
        </ListSubHeader>
        <NavItem matchPath={['/users-teams']} to="/users-teams">
          <Falcon icon="user"/>
          <Trans comment="Link to users & teams settings">Users & teams</Trans>
        </NavItem>
        {userRole.can('manage:settings') && (<NavItem matchPath={['/settings']} to="/settings/profile">
            <Falcon icon="cog"/>
            <Trans comment="Link to company settings">Account</Trans>
          </NavItem>)}
        {userRole.can('manage:integrations') && (<NavItem matchPath={['/integrations']} to="/integrations">
            <Falcon icon="puzzle-piece"/>
            <Trans comment="Link to integrations">Integrations</Trans>
          </NavItem>)}
      </StyledList>
    </Fragment>);
}
